<template>
  <div>
    <div class="upgrade-alert rounded-5">
      <div class="d-flex flex-wrap justify-content-start align-items-center">
        <!-- ALERT MESSAGE -->
        <div
          class="alert-msg color_text d-flex justify-content-start align-items-center nowrap"
        >
          <div class="mr-2">
            <img v-lazy="localImg('GiftBox.png')" alt="G.Box" />
          </div>

          <div>
            Get
            <span class="font-weight-600">#Back2School </span>with Gradely
            CatchUp! at <span class="strike-through">15,000</span> 10,000/year
            and win a free gift
          </div>
        </div>

        <template>
          <!-- ALERT CTA -->
          <div class="alert-cta" @click="logClaimClick">
            <router-link
              :to="{
                name:
                  account_type === 'student'
                    ? 'StudentUpgradePlan'
                    : 'ParentUpgradePlan',
                query: { type: 'catchup' },
              }"
              class="btn btn-whitish"
              >Claim offer now</router-link
            >
          </div>
        </template>
      </div>

      <!-- CLOSE ALERT -->
      <div class="avatar pointer" @click="close">
        <span
          class="icon-decline flex-center border_grey_dark font-weight-600 font-18"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "BackToSchoolUpgradeAlertCard",

  computed: {
    getClaimClickDetails() {
      return {
        user_id: this.user_id,
        page_name: "feed_top",
        action_name: "back2school21",
        url: window.location.origin,
      };
    },
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
      user_id: this.$route.path.split("/")[3],
    };
  },

  methods: {
    ...mapActions(["getSubscriptionPaymentStatus", "logUserClick"]),

    close() {
      localStorage.show_subscripition_alert = false;
      this.$emit("closeUpgradeAlert");
    },

    logClaimClick() {
      this.logUserClick(this.getClaimClickDetails)
        .then((response) => {
          console.log("action log response", response);
        })
        .catch((err) => {
          console.log("error logging user action", err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.upgrade-alert {
  @include flex_row_between_nowrap;
  align-items: center;
  padding: 5px 15px;
  margin-bottom: 12px;
  background: #fceacf;

  @include breakpoint_max(md) {
    padding: 10px 15px;
  }

  @include breakpoint_max(sm) {
    padding: 10px;
  }

  .alert-msg {
    font-size: 14px;
    line-height: 19px;

    @include breakpoint_max(md) {
      width: 100%;
    }

    img {
      @include equal_min_edge(27);
      margin-right: 10px;

      @include breakpoint_max(sm) {
        @include equal_min_edge(25);
        margin-right: 7px;
      }

      @include breakpoint_max(xs) {
        @include equal_min_edge(23);
      }
    }

    @include breakpoint_max(sm) {
      font-size: 12.5px;
    }
    @include breakpoint_max(xs) {
      font-size: 12px;
    }
  }

  .alert-cta {
    margin-left: 10px;

    @include breakpoint_max(lg) {
      margin-left: 0;
      margin-top: 20px;
    }

    .btn {
      font-size: 10.5px !important;

      @include breakpoint_max(sm) {
        font-size: 10px !important;
      }
    }
  }

  .avatar {
    transition: all 0.3s ease-in-out;

    span {
      transition: all 0.3s ease-in-out;
    }

    &:hover {
      background: $brand_inverse_light;

      span {
        color: $border_grey_dark !important;
      }
    }

    .icon-decline {
      @include breakpoint_max(sm) {
        font-size: 16px !important;
        font-weight: 500 !important;
      }
    }
  }
}

.strike-through {
  text-decoration: line-through;
}
</style>
